import classNames from 'classnames';
import { LOADING_TYPES } from '../../../../utils/checkoutState';
import { getAssetUrl } from '../../../../utils/config';
import LoadingIndicator from '../../../atoms/LoadingIndicator';
import './style.scss';

type RemoveItemButtonProps = {
  itemId: string;
  isLoading: string;
  onRemoveItem: (id: string) => Promise<void>;
};

const RemoveItemButton = ({ itemId, isLoading, onRemoveItem }: RemoveItemButtonProps) => (
  <div className="remove-item">
    <LoadingIndicator
      isSmall
      contentClassName={classNames('remove-item__loading', {
        'remove-item__loading--visible': isLoading === LOADING_TYPES.itemRemove(itemId)
      })}
    />
    <button
      className={classNames('remove-item__remove', {
        'remove-item__remove--loading': isLoading === LOADING_TYPES.itemRemove(itemId),
        'cursor-disabled': !!isLoading
      })}
      type="button"
      onClick={() => onRemoveItem(itemId)}
      disabled={!!isLoading}
      data-test-id="item-remove"
    >
      <img
        className="remove-item__remove-icon"
        src={getAssetUrl('common/remove.svg')}
        data-test-id="item-remove-icon"
      />
    </button>
  </div>
);

export default RemoveItemButton;
